import { BaseUrl } from "./baseUrls";

export async function uploadGeneralExtendedData(formData: any) {
    const url = `${BaseUrl}/uploadGeneralExtendedData`;
    return fetch(url, {
        method: 'POST',
        body: formData,
    });
}
